// extracted by mini-css-extract-plugin
export default {"rejectBillingAgreementDialog":"Fw6Z5","reasonField":"rpXpS","reasonLabel":"OObTZ","formActions":"AY71y","formBtn":"RVpwz","submissionMessage":"L9IKB"};